const auth = {
  en: {
    auth: {
      // Login
      welcomeBack: 'Welcome back',
      signInTo: 'Sign in to {appName}',
      errorInvalidCredentials: 'Invalid email or password.',
      errorGoogleFailed: 'Google sign-in failed.',
      continueWithGoogle: 'Continue with Google',
      orWithEmail: 'or with email',
      emailLabel: 'Email',
      emailPlaceholder: 'name@example.com',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Enter your password',
      forgotPassword: 'Forgot password?',
      signIn: 'Sign In',
      noAccount: "Don't have an account?",
      signUpFree: 'Sign up free',
      badgeSslEncrypted: 'SSL Encrypted',
      badgeRealtimeAI: 'Real-time AI',
      badgeFreeToUse: 'Free to Use',

      // Register
      createAccount: 'Create Account',
      createAccountBtn: 'Create Account',
      joinFree: "Join {appName} — it's free",
      errorPasswordsMismatch: 'Passwords do not match.',
      errorRegistrationFailed: 'Registration failed.',
      firstName: 'First Name',
      firstNamePlaceholder: 'John',
      lastName: 'Last Name',
      lastNamePlaceholder: 'Doe',
      username: 'Username',
      usernamePlaceholder: 'johndoe123',
      continueBtn: 'Continue',
      country: 'Country',
      countryPlaceholder: 'Select your country',
      birthMonth: 'Birth Month',
      birthMonthPlaceholder: 'Month',
      birthYear: 'Birth Year',
      birthYearPlaceholder: 'Year',
      back: 'Back',
      nextStep: 'Next Step',
      emailAddress: 'Email Address',
      passwordCreatePlaceholder: 'Create a password',
      confirmPassword: 'Confirm Password',
      confirmPasswordPlaceholder: 'Confirm your password',
      alreadyHaveAccount: 'Already have an account?',
      signInLink: 'Sign in',
      searchPlaceholder: 'Search...',
      noResults: 'No results found',
      months: {
        January: 'January',
        February: 'February',
        March: 'March',
        April: 'April',
        May: 'May',
        June: 'June',
        July: 'July',
        August: 'August',
        September: 'September',
        October: 'October',
        November: 'November',
        December: 'December',
      },

      // Page Not Found
      lostInTranslation: 'Lost in Translation?',
      notFoundDescription: "The page you are looking for doesn't exist or has been moved to another dimension.",
      backToHome: 'Back to Home',
      goBack: 'Go Back',

      // Loading
      synchronizing: 'Synchronizing Workspace',
    },
  },
  th: {
    auth: {
      // Login
      welcomeBack: 'ยินดีต้อนรับกลับมา',
      signInTo: 'เข้าสู่ระบบ {appName}',
      errorInvalidCredentials: 'อีเมลหรือรหัสผ่านไม่ถูกต้อง',
      errorGoogleFailed: 'เข้าสู่ระบบด้วย Google ไม่สำเร็จ',
      continueWithGoogle: 'ดำเนินการต่อด้วย Google',
      orWithEmail: 'หรือใช้อีเมล',
      emailLabel: 'อีเมล',
      emailPlaceholder: 'name@example.com',
      passwordLabel: 'รหัสผ่าน',
      passwordPlaceholder: 'กรอกรหัสผ่านของคุณ',
      forgotPassword: 'ลืมรหัสผ่าน?',
      signIn: 'เข้าสู่ระบบ',
      noAccount: 'ยังไม่มีบัญชี?',
      signUpFree: 'สมัครฟรี',
      badgeSslEncrypted: 'เข้ารหัส SSL',
      badgeRealtimeAI: 'AI แบบเรียลไทม์',
      badgeFreeToUse: 'ใช้งานฟรี',

      // Register
      createAccount: 'สร้างบัญชี',
      createAccountBtn: 'สร้างบัญชี',
      joinFree: 'เข้าร่วม {appName} — ฟรี',
      errorPasswordsMismatch: 'รหัสผ่านไม่ตรงกัน',
      errorRegistrationFailed: 'การสมัครไม่สำเร็จ',
      firstName: 'ชื่อจริง',
      firstNamePlaceholder: 'John',
      lastName: 'นามสกุล',
      lastNamePlaceholder: 'Doe',
      username: 'ชื่อผู้ใช้',
      usernamePlaceholder: 'johndoe123',
      continueBtn: 'ดำเนินการต่อ',
      country: 'ประเทศ',
      countryPlaceholder: 'เลือกประเทศของคุณ',
      birthMonth: 'เดือนเกิด',
      birthMonthPlaceholder: 'เดือน',
      birthYear: 'ปีเกิด',
      birthYearPlaceholder: 'ปี',
      back: 'ย้อนกลับ',
      nextStep: 'ขั้นตอนถัดไป',
      emailAddress: 'ที่อยู่อีเมล',
      passwordCreatePlaceholder: 'สร้างรหัสผ่าน',
      confirmPassword: 'ยืนยันรหัสผ่าน',
      confirmPasswordPlaceholder: 'ยืนยันรหัสผ่านของคุณ',
      alreadyHaveAccount: 'มีบัญชีอยู่แล้ว?',
      signInLink: 'เข้าสู่ระบบ',
      searchPlaceholder: 'ค้นหา...',
      noResults: 'ไม่พบผลลัพธ์',
      months: {
        January: 'มกราคม',
        February: 'กุมภาพันธ์',
        March: 'มีนาคม',
        April: 'เมษายน',
        May: 'พฤษภาคม',
        June: 'มิถุนายน',
        July: 'กรกฎาคม',
        August: 'สิงหาคม',
        September: 'กันยายน',
        October: 'ตุลาคม',
        November: 'พฤศจิกายน',
        December: 'ธันวาคม',
      },

      // Page Not Found
      lostInTranslation: 'หลงทางในการแปล?',
      notFoundDescription: 'หน้าที่คุณกำลังมองหาไม่มีอยู่ หรือถูกย้ายไปยังที่อื่นแล้ว',
      backToHome: 'กลับสู่หน้าแรก',
      goBack: 'ย้อนกลับ',

      // Loading
      synchronizing: 'กำลังซิงค์พื้นที่ทำงาน',
    },
  },
};

export default auth;
